import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Aux from "../../../../../../components/common/Aux";
import * as actionTypes from "../../../../../../store/actions";
import NavIcon from "./../NavIcon";
import NavBadge from "./../NavBadge";
import NavItem from "../NavItem";
import LoopNavCollapse from "./index";

const NavCollapse = ({ layout, isOpen, isTrigger, collapseMenu, onCollapseToggle, collapse, type, location }) => {

  useEffect(() => {
    const currentIndex = location.pathname.split("/").findIndex(id => id === collapse.id);
    if (currentIndex > -1) {
      onCollapseToggle(collapse.id, type)
    }
  }, [location.pathname, collapse.id, type]);

  const navItems = collapse.children ? Object.values(collapse.children).map(item => {
    switch (item.type) {
      case "collapse":
        return <LoopNavCollapse key={item.id} collapse={item} type="sub" />;
      case "item":
        return <NavItem layout={layout} key={item.id} item={item} />;
      default:
        return false;
    }
  }) : "";

  const isActive = id => location.pathname.split("/").findIndex(route => route === id) > -1;

  const navItemClass = ["nav-item", "pcoded-hasmenu"];
  const navLinkClass = ["nav-link"];
  if (isActive(collapse.id) || isOpen.includes(collapse.id)) {
    navItemClass.push("active");
    if (layout !== "horizontal") navLinkClass.push("active");
  }
  if (isTrigger.includes(collapse.id)) navItemClass.push("pcoded-trigger");

  const itemTitle = collapse.icon
    ? <span className="pcoded-mtext">{collapse.title}</span>
    : collapse.title;

  const subContent = collapseMenu ? (
    <Aux>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip style={{ pointerEvents: 'none' }}>{collapse.title}</Tooltip>}
      >
        <Link
          to="#"
          className={navLinkClass.join(" ")}
          onClick={() => onCollapseToggle(collapse.id, type)}
        >
          <NavIcon items={collapse} />
          {itemTitle}
          <NavBadge layout={layout} items={collapse} />
        </Link>
      </OverlayTrigger>
      <ul className="pcoded-submenu">{navItems}</ul>
    </Aux>
  ) : (
    <Aux>
      <Link
        to="#"
        className={navLinkClass.join(" ")}
        onClick={() => onCollapseToggle(collapse.id, type)}
      >
        <NavIcon items={collapse} />
        {itemTitle}
        <NavBadge layout={layout} items={collapse} />
      </Link>
      <ul className="pcoded-submenu">{navItems}</ul>
    </Aux>
  );

  const mainContent = <li className={navItemClass.join(" ")}>{subContent}</li>;

  return <Aux>{mainContent}</Aux>;
}


const mapStateToProps = state => ({
  layout: state.main.layout,
  isOpen: state.main.isOpen,
  isTrigger: state.main.isTrigger,
  collapseMenu: state.main.collapseMenu
});

const mapDispatchToProps = dispatch => ({
  onCollapseToggle: (id, type) =>
    dispatch({
      type: actionTypes.COLLAPSE_TOGGLE,
      menu: { id: id, type: type },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavCollapse));

